var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"pmlst-titlebar"}},[_c('div',{staticClass:"pmlst-titlebar-wrapper"},[_vm._t("default",[_c('h1',[_vm._v("Selection Tool")])])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }